<script>
    import { mount } from 'svelte';
    import Icon from 'views/components/icon/Icon.svelte'
    import Lightbox from 'views/components/lightbox/Lightbox.svelte';

    export let slides = []
    export let openAtSlide = null
    export let contextElement = null

    if (contextElement) {
        contextElement.addEventListener('click', openLightbox)
    }

    function openLightbox(e) {
        e.stopImmediatePropagation()

        mount(Lightbox, {
            target: document.body,
            props: {
                slides,
                openAtSlide,
            },
        })
    }
</script>

<button class="no-print" on:click={openLightbox}><Icon name="zoom-in"></Icon></button>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
button {
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 1;
  display: flex;
  padding: 8px;
  border-radius: 12px;
  cursor: zoom-in;
  background-color: rgba(0, 0, 0, 0.25);
  transition: background-color 0.2s;
}
button:hover {
  background-color: #000;
}
button :global(svg) {
  width: 16px;
  height: 16px;
  fill: #fff;
}</style>
